import {
    TEST,
} from '../actions/types';

const TestReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case TEST:
            return { ...state, msg: payload.msg };
        default:
            return state;
    }
};

const initialState = {
    msg: 'mensaje inicial',
};

export default TestReducer;